import type {FontId} from "../../themes/builder-constants";
import type React from "react";

import {InputGroup, ListBox, Popover, ScrollShadow, Typography} from "@heroui/react";
import {ExpandIcon, FontIcon} from "@project/icons-web";

import {fonts} from "../../themes/builder-constants";

import {LockableLabel} from "./lockable-label";
import {useThemeBuilder} from "./theme-builder-context";

export function FontFamilySelector() {
  const {params, setParam} = useThemeBuilder();
  const currentFont = fonts.find((f) => f.id === params.fontFamily);

  function handleSelectionChange(keys: Set<React.Key> | "all") {
    if (keys === "all") return;
    const id = [...keys][0] as FontId | undefined;

    if (id) setParam("fontFamily", id);
  }

  return (
    <Popover>
      <div className="flex flex-col gap-1">
        <LockableLabel label="Font Family" variable="fontFamily" />
        <Popover.Trigger>
          <InputGroup className="w-40 cursor-pointer">
            <InputGroup.Prefix className="w-10">
              <FontIcon className="size-4" />
            </InputGroup.Prefix>
            <InputGroup.Input
              readOnly
              className="max-w-20 cursor-pointer"
              id="font-family"
              name="font-family"
              value={currentFont?.label ?? "Inter"}
            />
            <InputGroup.Suffix className="w-10">
              <ExpandIcon className="size-3" />
            </InputGroup.Suffix>
          </InputGroup>
        </Popover.Trigger>
      </div>
      <Popover.Content className="w-81.25 rounded-3xl" placement="top">
        <Popover.Dialog className="p-3">
          <div className="mb-2 flex items-center justify-between">
            <Typography className="text-sm font-medium">Suggested</Typography>
          </div>
          <ScrollShadow hideScrollBar className="max-h-56 pb-3" size={15}>
            <ListBox
              disallowEmptySelection
              aria-label="Font family"
              selectionMode="single"
              layout="grid"
              selectedKeys={new Set([params.fontFamily])}
              className="grid grid-cols-3 gap-2 p-0"
              onSelectionChange={handleSelectionChange}
            >
              {fonts.map((font) => (
                <ListBox.Item
                  key={font.id}
                  id={font.id}
                  textValue={font.label}
                  className="group border-separator-on-surface data-[selected=true]:border-foreground data-[hovered=true]:bg-default relative flex h-20.75 w-23.75 flex-col items-center justify-center gap-1.25 rounded-2xl border"
                  style={{fontFamily: `"${font.label}", sans-serif`}}
                >
                  <span className="text-xl font-medium">Ag</span>
                  <Typography className="text-muted group-data-[selected=true]:text-foreground max-w-20 truncate text-[10px]">
                    {font.label}
                  </Typography>
                </ListBox.Item>
              ))}
            </ListBox>
          </ScrollShadow>
        </Popover.Dialog>
      </Popover.Content>
    </Popover>
  );
}
